// Constantes de colores
export const COLORS = {
  purple: '#a451e4',
  purpleLight: '#e8d5f2',
  blue: '#4c75aa',
  blueLight: '#d0edff',
  green: '#d5edb1',
  greenLight: '#eef8d9',
  greenDark: '#6aaa38',
  greenDarkLight: '#d2eac5',
  orange: '#fc8633',
  orangeLight: '#ffe2cc',
  editedBackground: '#e8f5e8',
  buttonGreen: '#4caf50',
  buttonGreenHover: '#45a049',
  buttonOrange: '#ff9800',
  buttonOrangeHover: '#f57c00',
  hoverBackground: '#e3f2fd',
  borderGray: '#ddd',
  textGray: '#666',
  blueHover: '#3a5a8c',
}

// Estilos para headers de columnas
export const getHeaderStyle = (backgroundColor, color = 'white') => ({
  backgroundColor: `${backgroundColor} !important`,
  color,
  fontWeight: 'bold',
  textAlign: 'center',
  fontSize: '14px !important',
})

export const getSubHeaderStyle = (backgroundColor, color = 'black') => ({
  backgroundColor: `${backgroundColor} !important`,
  color,
  fontWeight: 'bold',
  fontSize: '12px !important',
})

// Estilos para botones
export const getButtonStyle = (backgroundColor) => ({
  backgroundColor,
  color: 'white',
  border: 'none',
  borderRadius: '4px',
  padding: '6px 12px',
  cursor: 'pointer',
  fontSize: '12px',
  fontWeight: '500',
  transition: 'all 0.2s ease',
})

export const getButtonHoverStyle = (hoverColor) => ({
  backgroundColor: hoverColor,
  transform: 'scale(1.02)',
})

// Estilo para input de edición
export const editInputStyle = {
  width: '100%',
  border: '1px solid #2196f3',
  borderRadius: '4px',
  padding: '4px',
  outline: 'none',
  background: '#fff',
  fontSize: 'inherit',
  fontFamily: 'inherit',
  boxShadow: '0 0 0 2px rgba(33, 150, 243, 0.2)',
}

// Estilo para botón de restaurar
export const restoreButtonStyle = {
  backgroundColor: 'transparent',
  color: '#666',
  border: 'none',
  borderRadius: '3px',
  padding: '2px',
  cursor: 'pointer',
  fontSize: '10px',
  lineHeight: '1',
  width: '16px',
  height: '16px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  transition: 'all 0.2s ease',
}

// Estilo para celdas editadas
export const getEditedCellStyle = (isEdited) => isEdited ? {
  backgroundColor: `${COLORS.editedBackground} !important`,
} : {}

// Estilo para Typography editable
export const editableTypographyStyle = {
  cursor: 'pointer',
  padding: '4px',
  borderRadius: '4px',
  transition: 'all 0.2s ease',
  flex: 1,
  '&:hover': {
    backgroundColor: COLORS.hoverBackground,
    transform: 'scale(1.02)',
  }
}

// Estilos para el container principal
export const containerStyles = {
  tableContainer: {
    maxHeight: '600px',
    overflowX: 'auto',
  },
  tableRow: {
    '&:hover': {
      backgroundColor: '#f5f5f5',
    },
  },
  tablePaper: {
    elevation: 0,
    borderRadius: 0,
    border: `1px solid ${COLORS.borderGray}`,
  },
  footer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    mt: 2,
    gap: 2,
    borderTop: `1px solid ${COLORS.borderGray}`,
    pt: 2
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '0 16px'
  },
  editedCount: {
    fontSize: '14px',
    color: COLORS.textGray,
    fontWeight: '500'
  }
} 